import React from 'react'
import HeroImg from '../../../assets/images/company-formation/offshore-company-formation/hero-img.png'
import BannerImg from '../../../assets/images/company-formation/offshore-company-formation/banner-img.png'
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../components/Constant/List/List";
import { TiTick } from "react-icons/ti";
import { GoDotFill } from "react-icons/go";
import Button from "../../../components/Constant/button/Button";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import CTA from "../../../components/Constant/cta/CTA";
import SEO from "../../../utils/SEO";

const BreadCrumbsData = [
    {name: 'Offshore Advisory', link: '/'},
    {
        name: 'Offshore Company Formation',
        link: '/offshore-company-formation',
    },
]

function StVincentCompanyFormation() {
    return (
        <main className='main'>
            <SEO
                title="St. Vincent Company Formation | Offshore IBC Setup "
                description=" Incorporate a St. Vincent IBC with fast setup, privacy, and 0% offshore tax. Ideal for trading, holding, and international online businesses. "
                keywords="St Vincent company formation, SVG IBC, offshore company St Vincent, Caribbean company formation, zero tax offshore company, international business company SVG, offshore incorporation Caribbean, business setup St Vincent "
                url="/st-vincent-company-formation"
            />
            <section className='section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='container'>
                    <h1 className='section-title'>St. Vincent Company Formation</h1>
                    <br/>
                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>Fast & Affordable Offshore Incorporation in the Caribbean</h3>
                            <p className='page-paragraph'>
                                A <b> St. Vincent IBC (International Business Company) </b> is one of the most cost-effective offshore company types in the Caribbean. With <b> zero tax on offshore income, quick setup, and minimal compliance,</b> SVG companies are widely used for <b> trading, holding, and online businesses.</b>
                            </p>

                            <PageList
                                items={[
                                    {
                                        title: "Fast Setup",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Privacy",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "0% Tax on Offshore Income",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Cost-Effective",
                                        icon: TiTick,
                                    },
                                ]}
                            />
                            <Button
                                text="Request a St. Vincent Company Formation Proposal →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImg}/>
                    </div>
                    <BannerPageImg src={BannerImg}/>
                    <br/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>
                            Why Incorporate in St. Vincent?
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Affordable Incorporation",
                                    paragraph: "Lower fees than most offshore jurisdictions",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "0% Corporate Tax",
                                    paragraph: "No tax on offshore-sourced income",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Privacy",
                                    paragraph: "Directors & shareholders not publicly disclosed",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Simple Maintenance",
                                    paragraph: "No audits or complex reporting",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Fast Setup",
                                    paragraph: "Incorporation within days",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Key Features of St. Vincent IBC</h3>
                        <PageList
                            items={[
                                {
                                    title: "100% foreign ownership permitted",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Shareholders & Directors",
                                    paragraph: "At least 1 shareholder & 1 director (can be the same person)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "No minimum paid-up capital",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Local registered office & agent required",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "No annual filing or audits",
                                    paragraph: "Confidentiality protected by IBC law",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Benefits of SVG Companies</h3>
                        <PageList
                            items={[
                                {
                                    title: "0% Corporate Tax on foreign income",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "No Reporting Requirements",
                                    paragraph: "Reduces compliance costs",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Privacy & Confidentiality",
                                    paragraph: "Protected for owners",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Versatile Uses",
                                    paragraph: "Trading, forex, fintech, holding, consulting",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Low-Cost Setup",
                                    paragraph: "Ideal for startups and entrepreneurs",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Incorporation Requirements</h3>
                        <PageList
                            items={[
                                {
                                    title: "Shareholders & Directors",
                                    paragraph: "1 shareholder & 1 director (individual or corporate)",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Residency Requirement",
                                    paragraph: "No residency requirement",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Local Registered Agent & Office",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "KYC Documents",
                                    paragraph: "Passport, address proof, CV",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Incorporation Process
                        </h3>
                        <PageList
                            items={[
                                {
                                    title: "Consultation & Structuring",
                                    paragraph: "Decide on directors/shareholders",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Name Reservation",
                                    paragraph: "Company name approved",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Drafting of M&AA",
                                    paragraph: "Memorandum & Articles of Association",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Registrar Filing",
                                    paragraph: "Documents submitted to SVG registry",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Certificate of Incorporation issued",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Optional Add-Ons",
                                    paragraph: "Apostilles, nominees, bank account setup",
                                    icon: GoDotFill,
                                },
                            ]}
                        />


                        <h3 className='page-title'>Timeline & Costs</h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "2–5 business days",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Setup Cost",
                                    paragraph: "From USD 1,500+",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Renewal",
                                    paragraph: "Government fees, agent, and registered office",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>
                            Common Uses of SVG Companies
                        </h3>
                        <PageList
                            items={[
                                {
                                    paragraph: "Forex & brokerage back-office structure",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Crypto & fintech startups",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Holding company for assets & shares",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "Consulting or advisory services",
                                    icon: GoDotFill,
                                },
                                {
                                    paragraph: "E-commerce & digital businesses",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Why Offshore Advisory?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Direct partners with SVG registered agents",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Experience in forex, fintech, and brokerage setups",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Optional nominee & compliance services",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Comparative insights",
                                    paragraph: "SVG vs St. Lucia vs Seychelles vs Belize",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "End-to-end annual compliance support",
                                    icon: GoDotFill,
                                },
                            ]}
                        />


                    </div>


                    <FAQList title='Frequently Asked Questions (FAQ)' data={faqData} />

                    <Testimonials title='Client Testimonials' testimonials={testimonialsData}/>

                    <CTA
                        title="Looking for a cost-effective offshore solution?"
                        description="A <b>St. Vincent IBC</b> offers speed, tax neutrality, and privacy — ideal for forex, fintech, and holding structures."
                        buttonText="Book a St. Vincent Company Formation Consultation  →"
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    )
}

export default StVincentCompanyFormation

const faqData = [
    {
        question: "Do SVG companies pay tax?",
        content: [
            { type: "answer", text: "No — 0% corporate tax on offshore income." },
        ],
    },
    {
        question: "Is there a capital requirement?",
        content: [
            { type: "answer", text: "No — companies can be formed with USD 1 share capital." },
        ],
    },
    {
        question: "Can foreigners own 100%?",
        content: [
            { type: "answer", text: "Yes — foreign ownership is fully permitted." },
        ],
    },
    {
        question: "Do companies need to file audited accounts?",
        content: [
            { type: "answer", text: "No — no filing or audit requirements." },
        ],
    },
    {
        question: "How long does incorporation take?",
        content: [
            { type: "answer", text: "Usually 2–5 business days." },
        ],
    },
];


const testimonialsData = [
    {
        quote:
            "We used a St. Vincent IBC to structure our forex operations. Offshore Advisory handled incorporation and compliance seamlessly.",
        author: "Ahmed R.",
        role: "Broker CEO",
    },
    {
        quote:
            "Our fintech startup registered in SVG for its flexibility. Offshore Advisory guided us with nominee and apostille services.",
        author: "Laura P",
        role: "FinTech Founder",
    },
];